import { decodeToken, findHighestRole } from '../utils/userRole'
import auth from '../auth'
export class HttpError extends Error {
  constructor(message, status) {
    super(message)
    this.status = status
  }
}

const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
}

const fetchWithAuth = (path, options = {}, useAuth = false) => {
  const isFormData = options.body instanceof FormData
  
  // If headers are explicitly provided, use them; otherwise build defaults
  const headers = options.headers 
    ? { ...options.headers }
    : { ...(isFormData ? {} : DEFAULT_HEADERS) }

  // Add auth token if needed
  const token = auth.token.value

  if (useAuth && token) {
    const decodedToken = decodeToken(token)
    const highestUserRole = findHighestRole(decodedToken)
    const userRole = localStorage.getItem('userMode')

    headers.Authorization = `Bearer ${token}`

    if (userRole && highestUserRole !== userRole) {
      headers['X-Gateway-Access-Level-Downgrade'] = userRole.toUpperCase()
    }
  }

  const mergedOptions = {
    ...options,
    headers,
  }

  return fetch(`${import.meta.env.VITE_COSS_URL}/${path}`, mergedOptions)
}

const fetchSH = async (param, options, useAuth = true) => {
  const res = await fetchWithAuth(param, options, useAuth)

  if (res.ok) {
    if (res.status === 204) {
      return res.text()
    }

    return res.json()
  }

  if (res.status === 401) {
    localStorage.clear()
    if (window.location.pathname !== '/login') window.location.href = '/'
  }

  const err = await res.json()
  throw new HttpError(err.message, res.status || res.code)
}

export { fetchWithAuth, fetchSH }
